import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { createStore, bindActionCreators, applyMiddleware } from 'redux';
import { connect, Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import thunk from 'redux-thunk';
import LeftmenuReducers from '../../reducers/leftmenu.reducers';
import LeftmenuActiveComp from './leftmenu';
import * as leftmenuActions from '../../actions/leftmenu.actions';
import i18n from '../../../i18n';
import { getLeftMenuKey, getTopMenuKey } from '../../../utils/common';

const leftMenuMapsStateToProps = (state) => ({
  leftmenuData: state,
});

const leftMenuMapsDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(leftmenuActions, dispatch),
});


const LeftmenuApp = connect(leftMenuMapsStateToProps, 
  leftMenuMapsDispatchToProps)(LeftmenuActiveComp);

let leftmenuStore;
const leftmenuComp = function (data) {
  leftmenuStore = createStore(LeftmenuReducers, data, applyMiddleware(thunk));
  createRoot(document.getElementById('leftmenu_navigation')).render(
    <Provider store={leftmenuStore}>
      <Suspense fallback="loading...">
        <I18nextProvider i18n={i18n}>
          <LeftmenuApp />
        </I18nextProvider>
      </Suspense>
    </Provider>,
  );
}

const leftMenuModel = {
  reloadMenu: (args) => {
    if (typeof args.type !== 'undefined') {
      const id =
            typeof args.id !== 'undefined' && args.id !== null ? args.id : '';
      const objType =
          typeof args.objType !== 'undefined' && args.objType !== null
            ? args.objType
            : '';
      console.log('reloadMenu', args);
      //loadLeftMenuData(args.type, id, objType);
      if (typeof leftmenuStore !== 'undefined') {
        leftmenuStore.dispatch(
          leftmenuActions.ActiveLeftMenuId(args.type, id, objType, true)
        );
      }
    }
  },
  activeMenu: (args) => {
    const { objectId = '', objectType = '' } = args;
    let { menuId } = args;
    if (typeof menuId !== 'undefined') {
      if (menuId === 'objectives') {
        menuId = 'goal';
      } else if (menuId === 'meetings') {
        menuId = 'meeting';
      } else if (menuId === 'teams') {
        menuId = 'team';
      }
      if (typeof leftmenuStore !== 'undefined') {
        leftmenuStore.dispatch(
          leftmenuActions.ActiveLeftMenuId(menuId, objectId, objectType)
        );
      }
      if (menuId == '') {
        if (typeof topMenuModel !== 'undefined') {
          topMenuModel.activeMenuItem({ menuName: '' });
        }
      }
    }
  },
  updateMenuItem: (args) => {
    const { objectId, objectType, actionType, data = {} } = args;
    const pageId = getLeftMenuKey(args.pageId);
    if (pageId && typeof leftmenuStore !== 'undefined') {
      if (actionType == 'update') {
        leftmenuStore.dispatch(
          leftmenuActions.UpdateLeftMenuData(pageId, objectId, objectType, data)
        );
      } else if (actionType == 'delete') {
        leftmenuStore.dispatch(
          leftmenuActions.DeleteLeftMenuData(pageId, objectId, objectType)
        );
      } else if (actionType == 'pin') {
        let pinData = {};
        if (Array.isArray(data.pinData)) {
          pinData = data.pinData.find(p => p.obj_id == objectId);
        }

        leftmenuStore.dispatch(
          leftmenuActions.PinLeftMenuData(
            pageId,
            objectId,
            data.status,
            pinData,
            objectType
          )
        );

        leftMenuModel.favoriteMenuItem(pageId);
      } else if (actionType === 'mywork_count_update') {
        leftmenuStore.dispatch(
          leftmenuActions.UpdateMyWorkCount(pageId, data)
        );
      } else if (actionType === 'krs_count_update') {
        leftmenuStore.dispatch(
          leftmenuActions.UpdateKrsCount(pageId, data)
        );
      }
    }
  },
  highlightMenuItem: (args) => {
    const { menuId, objectId, objectType, additionalParams = '' } = args;
    if (typeof leftmenuStore !== 'undefined') {
      leftmenuStore.dispatch(
        leftmenuActions.HighLightedLeftMenuObjectId(
          menuId,
          objectId,
          objectType,
          additionalParams
        )
      );
    }
  },
  favoriteMenuItem: (type) => {
    if (typeof leftmenuStore !== 'undefined') {
      const storeVal = leftmenuStore.getState();
      if (typeof storeVal[type] !== 'undefined') {
        leftMenuModel.updateTopmenuFavorites(type, storeVal[type].menus);
      }
    }
  },
  updateTopmenuFavorites: (menuId, menus = []) => {
    if (menuId !== 'mywork' && Array.isArray(menus)) {
      const favoritesMenu = menus.filter(m => (
        typeof m.id !== 'undefined' 
        && m.id != null && new String(m.id).indexOf('favorites') > -1
      ));
      let topMenuItems = [];
      if (favoritesMenu.length) {
        topMenuItems = favoritesMenu[0].menus;
      }
      if (Array.isArray(topMenuItems) && topMenuItems.length) {
        if (topMenuItems.length > 5) {
          topMenuItems = topMenuItems.slice(0, 5);
        }
      }
      setTimeout(() => {
        if (typeof topMenuModel !== 'undefined' && Array.isArray(topMenuItems)) {
          topMenuModel.reloadMenuItems({
            keyTop: getTopMenuKey(menuId),
            topmenuFavorites: topMenuItems
          });
        }
      }, 10);
    }
  }
}
window.leftMenuModel = Object.create(leftMenuModel);
window.leftmenuComp = leftmenuComp;
